import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Zap, Gift, Users, Briefcase } from 'lucide-react';
import { BalanceCard, FaucetClaim, LevelProgress, DailyQuests } from '../components';

const QUICK_ACTIONS = [
  { 
    path: '/earn', 
    icon: Zap, 
    label: 'Auto Earn', 
    desc: 'Passive income',
    color: 'from-green-500 to-emerald-500' 
  },
  { 
    path: '/offers', 
    icon: Briefcase, 
    label: 'Offers', 
    desc: 'Complete tasks',
    color: 'from-purple-500 to-pink-500' 
  },
  { 
    path: '/games', 
    icon: Gift, 
    label: 'Games', 
    desc: 'Win prizes',
    color: 'from-orange-500 to-red-500' 
  },
  { 
    path: '/referral', 
    icon: Users, 
    label: 'Friends', 
    desc: 'Earn together',
    color: 'from-blue-500 to-cyan-500' 
  },
];

export function HomePage() {
  return (
    <div className="space-y-5">
      {/* Balance overview */}
      <BalanceCard />

      {/* Quick Actions Grid */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="grid grid-cols-4 gap-2"
      >
        {QUICK_ACTIONS.map((action) => (
          <Link
            key={action.path}
            to={action.path}
            className="flex flex-col items-center p-3 rounded-xl bg-white/5 hover:bg-white/10 transition-colors"
          >
            <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${action.color} flex items-center justify-center mb-2`}>
              <action.icon className="w-5 h-5 text-white" />
            </div>
            <span className="text-xs font-medium text-white">{action.label}</span>
            <span className="text-[10px] text-white/50">{action.desc}</span>
          </Link>
        ))}
      </motion.div>

      {/* Banner Ad */}

      {/* <OnclickaBanner /> */}

      {/* Level progress */}
      <LevelProgress />

      {/* Hourly faucet claim */}
      <FaucetClaim />

      {/* GigaPub Native Ad */}
      {/* <GigaPubNativeAd /> */}

      {/* Daily quests preview */}
      <DailyQuests />
    </div>
  );
}
